/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putActivitySubscription.defs.js'
export * as $defs from './putActivitySubscription.defs.js'
